<template>
  <div>
    <div ref="backDiv" id="back-div" v-show="isActive" class="back-div"></div>
    <div
      id="drawer"
      class="drawer"
      :class="{ active: isActive }"
      :style="getStyle()"
    >
      <a class="hamburger clearfix theme-link" @click.prevent="$emit('closed')">
        <span class="material-icons md-36">menu</span>
      </a>
      <ul class="nav flex-column clearfix" :style="getStyle" v-if="user">
        <template v-if="currentStoreDoc">
          <li class="nav-item">
            <router-link class="nav-link active theme-link" to="/profile">
              {{ $t("message.myAccount") }}
            </router-link>
          </li>
          <li class="nav-item" v-if="storeSupportsLoyaltyPoints || storeSupportEarningLoyaltyPoints">
            <router-link
              class="nav-link theme-link"
              :to="{
                name: 'loyalty',
                params: {
                  storeid: currentStoreDoc.ID,
                  storename: currentStoreDoc.Name,
                },
              }"
              >{{ $t("message.loyalty") }}</router-link
            >
          </li>
          <li class="nav-item">
            <router-link
              class="nav-link theme-link"
              :to="{
                name: 'orderhistory',
                params: {
                  storeid: currentStoreDoc.ID,
                  storename: currentStoreDoc.Name,
                },
              }"
              >{{ $t("message.orderHistory") }}</router-link
            >
          </li>
          <li class="nav-item">
            <router-link
              class="nav-link theme-link"
              :to="{
                name: 'ordertracking',
                params: {
                  storeid: currentStoreDoc.ID,
                  storename: currentStoreDoc.Name,
                },
              }"
              >{{ $t("message.orderTracking") }}</router-link
            >
          </li>
        </template>
        <li class="nav-item" v-if="$route.name != 'mainpage'">
          <a class="nav-link theme-link" href="#" @click="goToMainPage">
            {{ capitalizeFirstLetter($t("message.stores")) }}
          </a>
        </li>
        <li class="nav-item" v-if="isRolldStore()">
          <a class="nav-link theme-link" href="https://rolld.com.au">
            {{ $t("message.backToHome") }}
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link theme-link" href="#" @click="signOut">
            {{ $t("message.logOut") }}
          </a>
        </li>
      </ul>
      <ul class="nav flex-column clearfix" v-else-if="viewConfig.LogIn">
        <li class="nav-item">
          <a class="nav-link theme-link active" @click="openLogin">
            {{ $t("message.login") }}
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link active" @click="openLogin">
            {{ $t("message.register") }}
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link theme-link" href="#" @click="goToMainPage">
            {{ capitalizeFirstLetter($t("message.stores")) }}
          </a>
        </li>
        <li class="nav-item" v-if="isRolldStore()">
          <a class="nav-link theme-link" href="https://rolld.com.au">
            {{ $t("message.backToHome") }}
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import { capitalizeFirstLetter } from "../../filters/capitalizeFirstLetter";

export default {
  name: "Drawer",

  props: {
    isActive: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters([
      "user",
      "cartValue",
      "viewConfig",
      "mobileStyles",
      "currentStoreDoc",
      "storeSupportsLoyaltyPoints",
      "hqDoc",
      "storeSupportEarningLoyaltyPoints",
    ]),
  },

  mounted() {
    const that = this;
    if (this.$refs.backDiv) {
      this.$refs.backDiv.onclick = function () {
        if (that.isActive) {
          that.$emit("closed");
        }
      };
    }
  },
  methods: {
    ...mapActions(["logout"]),
    ...mapMutations(["setShowOverlay"]),
    capitalizeFirstLetter,
    signOut() {
      this.logout();
      this.navigateShoppingcart();
    },
    navigateShoppingcart() {
      if (window.location.pathname.indexOf("giftcards") != -1)
        this.$router.push("/store/" + this.currentStoreDoc.Name + "/giftcards");
      else this.$router.push("/store/" + this.currentStoreDoc.Name);
    },
    getStyle() {
      var styles = [];
      styles.push(this.mobileStyles.primaryColourImportant);
      styles.push(this.mobileStyles.nav);
      styles.push(this.mobileStyles.navText);
      return styles;
    },
    openLogin() {
      this.$emit("closed");
      this.setShowOverlay(true);
    },
    goToMainPage() {
      if (this.$route.name === "mainpage") {
        this.$emit("closed");
      } else {
        this.$router.push({ name: "mainpage" });
      }
    },
  },
};
</script>
